import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { getConsent } from "@/lib/consent";

// Mobile-only sticky CTA. Hidden while the cookie banner is undecided (so the
// banner is never covered) and once the final register CTA is in view.
export const StickyMobileCta = () => {
    const [ctaInView, setCtaInView] = useState(false);
    const [consentPending, setConsentPending] = useState(() => !getConsent());

    useEffect(() => {
        const els = [
            document.querySelector('[data-testid="hero-cta-register"]'),
            document.querySelector('[data-testid="final-cta"]'),
        ].filter(Boolean);
        if (!els.length || typeof IntersectionObserver === "undefined") return;
        const vis = new Map();
        const obs = new IntersectionObserver((entries) => {
            entries.forEach((e) => vis.set(e.target, e.isIntersecting));
            setCtaInView([...vis.values()].some(Boolean));
        }, { threshold: 0.15 });
        els.forEach((el) => obs.observe(el));
        return () => obs.disconnect();
    }, []);

    useEffect(() => {
        const done = () => setConsentPending(false);
        window.addEventListener("cookie-consent-changed", done);
        return () => window.removeEventListener("cookie-consent-changed", done);
    }, []);

    if (ctaInView || consentPending) return null;
    return (
        <div
            className="sm:hidden fixed bottom-0 inset-x-0 z-[60] border-t border-border bg-card/95 backdrop-blur px-4 pt-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]"
            data-testid="sticky-mobile-cta"
        >
            <Link
                to="/register"
                className="flex items-center justify-center gap-2 h-12 w-full rounded-full bg-accent text-accent-foreground font-display font-semibold text-base focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
                data-testid="sticky-cta-register"
            >
                Start free <ArrowRight className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" />
            </Link>
        </div>
    );
};
